import getPageTemplate from '../selectors/page-template';
import setPageTemplateHTML from '../actions/set-page-template-html';
import site from '../../site';
import errors from '../../errors';
import normalizeLocalizedSource from '../../site-locales/helpers/normalize-localized-source';
import clearPageTemplatesHtml from '../../site-locales/actions/clear-page-templates-html';
import getCurrentLocale from '../../site-locales/selectors/current-locale';
import getPageLocaleById from '../../site-locales/selectors/page-locale-by-id';
import base64Decode from '../../../utils/base64-decode';

const templateFetcher = (store) => (next) => (action) => {
  switch (action.type) {
    case site.actionTypes.CREATE_PAGE_FROM_TEMPLATE: {
      const state = store.getState();
      const pageTemplate = getPageTemplate(state, action.payload.pageTemplateId);

      if (!pageTemplate || pageTemplate.html) {
        next(action);
        return;
      }
      const locale = getCurrentLocale(state);

      site.helpers
        .fetchAsset(normalizeLocalizedSource(pageTemplate.source, locale), { encode: true })
        .then((response) => {
          const pageTemplateHtml = base64Decode(response.data);
          store.dispatch(setPageTemplateHTML(pageTemplate.id, pageTemplateHtml));
          next(action);
        })
        .catch((error) => {
          errors.operations.catchError(error);
        });

      break;
    }

    case site.actionTypes.SET_ACTIVE_PAGE: {
      const state = store.getState();
      const activePageLocale = getCurrentLocale(state);
      const nextActivePageLocale = getPageLocaleById(state, action.payload.pageId);

      if (nextActivePageLocale !== activePageLocale) {
        store.dispatch(clearPageTemplatesHtml());
      }
      next(action);
      break;
    }

    default:
      next(action);
  }
};

export default templateFetcher;
